'use client'

// Global 404 — branded on the marketing design system (.mk tokens from
// marketing-ui.tsx) since unauthenticated visitors are the most common
// audience for a bad URL. Authenticated users get a path back in via /home.

import Link from 'next/link'
import { Instrument_Serif } from 'next/font/google'
import { MARKETING_CSS } from './marketing-ui'

const instrumentSerif = Instrument_Serif({
  subsets: ['latin'],
  weight: '400',
  style: ['normal', 'italic'],
  display: 'swap',
  variable: '--font-display',
})

export default function NotFound() {
  return (
    <div
      className={`mk ${instrumentSerif.variable}`}
      style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}
    >
      <style>{MARKETING_CSS}</style>

      <header style={{ padding: '20px 24px' }}>
        <Link href="/" style={{ display: 'inline-flex', alignItems: 'center' }}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/logo-text-green.png" alt="Obi-Hub" style={{ height: 26, width: 'auto' }} />
        </Link>
      </header>

      <main
        style={{
          flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '48px 24px 96px',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: 560 }}>
          <p className="mk-eyebrow mk-eyebrow--center">404 · Page not found</p>
          <h1 className="mk-display" style={{ fontSize: 'clamp(34px, 5vw, 54px)', marginBottom: 18 }}>
            This page came apart <em>at the seams</em>
          </h1>
          <p className="mk-lead" style={{ marginBottom: 32 }}>
            The page you&rsquo;re looking for doesn&rsquo;t exist or has moved.
            Check the URL, or head back to somewhere that does.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link href="/" className="mk-btn" style={{ padding: '10px 22px', fontSize: 14, borderRadius: 8 }}>
              Back to the homepage
            </Link>
            <Link href="/home" className="mk-btn mk-btn--ghost" style={{ padding: '10px 22px', fontSize: 14, borderRadius: 8 }}>
              Open Obi-Hub
            </Link>
          </div>
        </div>
      </main>
    </div>
  )
}
